import { Box, Button, CircularProgress, FormControl, Select, TextField } from '@mui/material'
import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import './transactionlog.css'

import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { API_BASE_URL } from '../../../utility/apiConstants'
import { getAuth } from '../../../utility/apiConfig'
import { useSelector } from 'react-redux'
import { Pagination } from '@mui/material';
import { formatDate2, IST_DDMMYYYY_T } from '../../../core/helper'
import exportFromJSON from 'export-from-json'

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: '100%'
  },
  formControl: {
    marginTop: '16px',
    marginBottom: '8px'

  },
  selectEmpty: {
    marginTop: theme.spacing(0)
  }
}))

const TransactionLog = () => {
  const classes = useStyles()
  const user = useSelector(state => state.user)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [type, setType] = useState('')
  const [app_reference, setApp_reference] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [transactionLogs, setTransactionLogs] = useState(null)
  const totalrecords = (transactionLogs) ? transactionLogs.total_records : 0
  const [activePage, setActivePage] = useState(1)

  const [isOpen, setIsOpen] = useState('')
  const [isToOpen, setIsToOpen] = useState('')

  const handleSearch = (val) => {
    const data = {
      transaction_type: type,
      app_reference: app_reference.trim(),
      created_datetime_from: fromDate,
      created_datetime_to: toDate,
      agent_id: user.userDetails.user_id
    }
    try {
      setIsLoading(true)
      getAuth(API_BASE_URL + 'transaction/logs/', { params: data })
        .then((response) => {
          const data = response.data.data
          setTransactionLogs(data)
          setIsLoading(false)
        })
        .catch((error) => {
        })
    } catch (error) {

    }
  }
  const handleSearch2 = (val) => {
    const data = {
      transaction_type: type,
      app_reference: app_reference.trim(),
      created_datetime_from: fromDate,
      created_datetime_to: toDate,
      agent_id: user.userDetails.user_id
    }
    try {
      setIsLoading(true)
      const pagecount = (val == 1) ? 1 : (val - 1) * 50
      getAuth(API_BASE_URL + 'transaction/logs/' + pagecount, { params: data })
        .then((response) => {
          const data = response.data.data
          setTransactionLogs(data)
          setIsLoading(false)
        })
        .catch((error) => {
        })
    } catch (error) {

    }
  }
  const handleReset = () => {
    window.location.reload()
  }

  const handleChange = (event, value) => {
    setActivePage(value)
   handleSearch2(value)
  }

  const handleExport = () => {
    const data = {
      transaction_type: type,
      app_reference: app_reference.trim(),
      created_datetime_from: fromDate,
      created_datetime_to: toDate,
      agent_id: user.userDetails.user_id
    }
    try {
      getAuth(API_BASE_URL + '/transaction/export_logs/excel/', { params: data })
        .then((response) => {
          if (response.data.status) {
            const transData = []
            response.data.data.map((s, i) => {
              const transDataObj = {}
              transDataObj['Sl. No.'] = i + 1
              transDataObj.Agent = s.domain_name
              transDataObj['Transaction Date'] = s.transaction_date
              transDataObj['Reference Number'] = s.reference_number
              transDataObj['Transaction Type'] = s.transaction_type
              transDataObj.Amount = s.amount_in_admin_currency
              transDataObj.Description = s.description
              transDataObj['Closing Balance'] = s.closing_balance
              transData.push(transDataObj)
            })
            const data = transData
            const date = IST_DDMMYYYY_T()
            const fileName = 'transactionLogs_' + date
            const exportType = 'xls'
            exportFromJSON({ data, fileName, exportType })
          }

          setIsLoading(false)
        })
        .catch((error) => {
          setIsLoading(false)
        })
    } catch (error) {

    }
    // exportFromJSON({ data, fileName, exportType })
  }

  return (
    <div>
      <Container fluid className="ledgerContainer">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box className="tlt-ledger">Transaction Logs</Box>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <form>
              <Row className="account-ledger">
                <Col xs={6} sm={6} md={3} lg={3} xl={3}>
                  <FormControl variant="outlined" className={classes.formControl} size="small">
                    <Select value={type} native onChange={(e) => setType(e.target.value)}>
                      <option value={''}>All</option>
                      <option value={'Flight'}>Flight</option>
                      <option value={'Hotel'}>Hotel</option>
                      <option value={'Bus'}>Bus</option>
                      <option value={'Transfers'}>Transfers</option>
                      <option value={'Activities'}>Activities</option>
                      <option value={'Transaction'}>Transaction-(Deposits/Others)</option>
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={6} sm={6} md={3} lg={3} xl={3}>
                  <TextField
                    className={classes.formControl}
                    variant="outlined"
                    placeholder="Request Number"
                    size="small"
                    minWidth="100%"
                    value={app_reference}
                    onChange={event => { setApp_reference(event.target.value) }}
                  >
                  </TextField>
                </Col>
                <Col xs={6} sm={6} md={3} lg={3} xl={3}>
                  <MuiPickersUtilsProvider className="uiboxofdate" spacing={0} utils={DateFnsUtils}>
                    <KeyboardDatePicker className="editdob m-auto"
                      margin="normal"
                      variant="inline"
                      disableToolbar
                      autoOk
                      inputVariant="outlined"
                      size="small"
                      id="date-picker-dialog"
                      format="dd-MMM-yyyy"
                      value={fromDate}
                      disableFuture
                      maxDate={new Date()}
                      emptyLabel="From Date"
                      onChange={(e) => setFromDate(e)}

                      onChange={(e) => {
                        setFromDate(e)
                        setIsOpen(false)
                      }}
                      KeyboardButtonProps={{
                        onFocus: e => {
                          setIsOpen(true)
                        }
                      }}
                      PopoverProps={{
                        disableRestoreFocus: true,
                        onClose: () => {
                          setIsOpen(false)
                        }
                      }}
                      InputProps={{
                        onFocus: () => {
                          setIsOpen(true)
                        }
                      }}
                      open={isOpen}

                      // KeyboardButtonProps={{
                      //   "aria-label": "change date"
                      // }}
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Col xs={6} sm={6} md={3} lg={3} xl={3}>
                  <MuiPickersUtilsProvider className="uiboxofdate" spacing={0} utils={DateFnsUtils}>
                    <KeyboardDatePicker className="editdob m-auto"
                      margin="normal"
                      variant="inline"
                      disableToolbar
                      autoOk
                      inputVariant="outlined"
                      size="small"
                      id="date-picker-dialog"
                      format="dd-MMM-yyyy"
                      value={toDate}
                      disableFuture
                      minDate = {fromDate}
                      maxDate={new Date()}
                      emptyLabel="To Date"
                      onChange={(e) => setToDate(e)}

                      onChange={(e) => {
                        setToDate(e)
                        setIsToOpen(false)
                      }}
                      KeyboardButtonProps={{
                        onFocus: e => {
                          setIsToOpen(true)
                        }
                      }}
                      PopoverProps={{
                        disableRestoreFocus: true,
                        onClose: () => {
                          setIsToOpen(false)
                        }
                      }}
                      InputProps={{
                        onFocus: () => {
                          setIsToOpen(true)
                        }
                      }}
                      open={isToOpen}

                      // KeyboardButtonProps={{
                      //   "aria-label": "change date"
                      // }}
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Box className="btntrasactionlog">
                  <Button
                    className="btntrnlog"
                    variant="contained"
                    color="primary"
                    onClick={handleSearch}
                    disabled={isLoading}
                  >{isLoading ? (<CircularProgress size={24} color="inherit" />) : 'Search'}</Button>
                  {/* <Button className="btntrnlog" variant="contained" color="secondary">Reset</Button> */}
                  <Button className="btntrnlog clear" variant="contained" onClick={handleReset}>Clear Filter</Button>
                </Box>
              </Row>
              {/* <Row>
                <Box className="btnboxexport"><Button variant="contained" onClick={handleExport} color="primary" className="exportbtn">Export to excel</Button></Box>
              </Row> */}
            </form>
          </Col>
        </Row>
        <Row>
        <Col xs={6} sm={6} md={12} lg={12} xl={12}>
                {totalrecords
                  ? <Button
                                        className="exportledger"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleExport}
                                        disabled={isLoading}
                                        >{isLoading ? (<CircularProgress size={24} color="inherit" />) : 'Export to excel'}</Button>
                  : ''}
                    </Col>
          <Box className="tlt-content-ledger">Total {totalrecords} transaction found</Box>
          <Box className="table-box-found">
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="customized table">
                <TableHead className="ledgertableheader">
                  <TableRow>
                    <StyledTableCell className="thledger" align="center">SI.No</StyledTableCell>
                    <StyledTableCell className="thledger" align="left">Trasaction Date</StyledTableCell>
                    <StyledTableCell className="thledger" align="left">Reference Number</StyledTableCell>
                    <StyledTableCell className="thledger" align="left">Trasaction Type</StyledTableCell>
                    <StyledTableCell className="thledger" align="left">Amount</StyledTableCell>
                    <StyledTableCell className="thledger" align="left">Description</StyledTableCell>
                  </TableRow>
                </TableHead>
                {!!transactionLogs && (
                  <TableBody>
                    {isLoading
                      ? <StyledTableRow><StyledTableCell colSpan={6} align="center"><CircularProgress size={24} color="inherit" /></StyledTableCell></StyledTableRow>
                      : (transactionLogs.table_data.map((row, i) => (
                      <StyledTableRow key={i}>
                        <StyledTableCell className="tdledger" align="center">{(activePage == 1) ? i + 1 : ((activePage - 1) * 50) + (i + 1)}</StyledTableCell>
                        <StyledTableCell className="tdledger" align="left"><div style={{width: "max-content"}}>{formatDate2(row.created_datetime)}</div></StyledTableCell>
                        <StyledTableCell className="tdledger" align="left">{row.app_reference}</StyledTableCell>
                        <StyledTableCell className="tdledger" align="left">{row.transaction_type}</StyledTableCell>
                        <StyledTableCell className="tdledger" align="left">{Math.abs(row.fare)}</StyledTableCell>
                        <StyledTableCell className="tdledger" align="left">{row.remarks}</StyledTableCell>
                      </StyledTableRow>
                        )))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>
          <Box className="paginationbox">
            {/* <Pagination count={10} color="primary" /> */}
            <Pagination count={Math.ceil(totalrecords / (!!transactionLogs && transactionLogs.per_page))} page={activePage} color="primary" onChange={handleChange} />
          </Box>
        </Row>
      </Container>
    </div>
  );
}

export default TransactionLog
